/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
import { NoBookingAlertCardAlertFragmentDoc } from '../NoBookingAlertCard/noBookingAlertCard.hook'
import { NoDriverAlertCardAlertFragmentDoc } from '../NoDriverAlertCard/noDriverAlertCard.hook'
import { OutOfServiceAreaAlertCardAlertFragmentDoc } from '../OutOfServiceAreaAlertCard/outOfServiceAreaAlertCard.hook'
import { PrebookingAlertCardAlertFragmentDoc } from '../PrebookingAlertCard/PrebookingAlertCard.hook'
import { VehicleHasLowSocAlertCardAlertFragmentDoc } from '../VehicleHasLowSocAlertCard/vehicleHasLowSocAlertCard.hook'
import { VehicleHasNoHubReturnAlertCardAlertFragmentDoc } from '../VehicleHasNoHubReturnAlertCard/vehicleHasNoHubReturnAlertCard.hook'
import { VehicleNotBookableAlertCardAlertFragmentDoc } from '../VehicleNotBookableAlertCard/vehicleNotBookableAlertCard.hook'
export type AlertCardAlert_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type AlertCardAlert_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_RoadBlockageTaskNotification_Fragment = {
  __typename?: 'RoadBlockageTaskNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_ShiftDeviationNotification_Fragment = {
  __typename?: 'ShiftDeviationNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_StopAccessibilityDownvotedByDrivers_Fragment = {
  __typename?: 'StopAccessibilityDownvotedByDrivers'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_StopActivationFailedNotification_Fragment = {
  __typename?: 'StopActivationFailedNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_StopAreaMissingActiveStopsNotification_Fragment = {
  __typename?: 'StopAreaMissingActiveStopsNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_StopPotentiallyUnreachable_Fragment = {
  __typename?: 'StopPotentiallyUnreachable'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_TimeManagementNotification_Fragment = {
  __typename?: 'TimeManagementNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_TripPrebookingNoAssignment_Fragment = {
  __typename: 'TripPrebookingNoAssignment'
  id: string
  notificationType: Types.TaskNotificationType
  status: Types.TaskNotificationStatus
  rejectionAt: string
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  trip: {
    __typename?: 'Trip'
    id: string
    customer: {
      __typename?: 'Customer'
      id: string
      firstName: string | null
      lastName: string | null
      phoneNumber: string | null
    } | null
    pickup: {
      __typename?: 'TripTransferInformation'
      promisedTime: {
        __typename?: 'DateTimeInterval'
        from: string
        to: string
      }
    }
    seatInfo: { __typename?: 'TripSeatInfo'; wheelchairs: number }
  } | null
  resolved: {
    __typename?: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
  } | null
  pickupStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  dropoffStop: {
    __typename?: 'Stop'
    id: string
    names: Partial<Record<'de' | 'en' | 'no', string>>
    address: {
      __typename?: 'StopAddress'
      street: string | null
      houseNumber: string | null
      postalCode: string | null
      city: string | null
    }
    routingLocation: {
      __typename?: 'Location'
      latitude: number
      longitude: number
    }
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertCardAlert_VehicleAvailabilityNotification_Fragment = {
  __typename?: 'VehicleAvailabilityNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_VehicleIncidentNotification_Fragment = {
  __typename?: 'VehicleIncidentNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlert_VehicleSurveillanceNotification_Fragment = {
  __typename: 'VehicleSurveillanceNotification'
  id: string
  notificationType: Types.TaskNotificationType
  status: Types.TaskNotificationStatus
  employee: {
    __typename?: 'Employee'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    highVoltageBatteryLevel: number | null
    cruisingRange: number | null
    totalPassengersInVehicle: number | null
    inService: boolean | null
    label: number | null
    licensePlate: string | null
    isSelfDriving: boolean
    hardwareConfiguration: {
      __typename?: 'HardwareConfiguration'
      tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
    } | null
    fleet: { __typename?: 'Fleet'; id: string } | null
    lastVehicleInteraction: {
      __typename?: 'VehicleInteraction'
      type: Types.VehicleInteractionType
    } | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export type AlertCardAlert_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  id: string
  notificationType: Types.TaskNotificationType
}

export type AlertCardAlertFragment =
  | AlertCardAlert_HubServiceNotification_Fragment
  | AlertCardAlert_IvcTaskNotification_Fragment
  | AlertCardAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | AlertCardAlert_PassengerUnbuckled_Fragment
  | AlertCardAlert_RoadBlockageTaskNotification_Fragment
  | AlertCardAlert_ShiftDeviationNotification_Fragment
  | AlertCardAlert_StopAccessibilityDownvotedByDrivers_Fragment
  | AlertCardAlert_StopActivationFailedNotification_Fragment
  | AlertCardAlert_StopAreaMissingActiveStopsNotification_Fragment
  | AlertCardAlert_StopDownVotedByDrivers_Fragment
  | AlertCardAlert_StopPotentiallyUnreachable_Fragment
  | AlertCardAlert_StopValidationFailed_Fragment
  | AlertCardAlert_TimeManagementNotification_Fragment
  | AlertCardAlert_TripPrebookingNoAssignment_Fragment
  | AlertCardAlert_VehicleAvailabilityNotification_Fragment
  | AlertCardAlert_VehicleIncidentNotification_Fragment
  | AlertCardAlert_VehicleSurveillanceNotification_Fragment
  | AlertCardAlert_VehicleWaypointAttendance_Fragment

export const AlertCardAlertFragmentDoc = gql`
    fragment AlertCardAlert on TaskNotification {
  id
  notificationType
  ... on VehicleSurveillanceNotification {
    ...OutOfServiceAreaAlertCardAlert
    ...NoBookingAlertCardAlert
    ...VehicleNotBookableAlertCardAlert
    ...VehicleHasLowSocAlertCardAlert
    ...NoDriverAlertCardAlert
    ...VehicleHasNoHubReturnAlertCardAlert
  }
  ... on TripPrebookingNoAssignment {
    ...PrebookingAlertCardAlert
  }
}
    ${OutOfServiceAreaAlertCardAlertFragmentDoc}
${NoBookingAlertCardAlertFragmentDoc}
${VehicleNotBookableAlertCardAlertFragmentDoc}
${VehicleHasLowSocAlertCardAlertFragmentDoc}
${NoDriverAlertCardAlertFragmentDoc}
${VehicleHasNoHubReturnAlertCardAlertFragmentDoc}
${PrebookingAlertCardAlertFragmentDoc}`
